export default __webpack_public_path__ + "static/media/PEN_70.eecbdd16.jpg";